module.exports = __webpack_public_path__ + "static/spinner-textprogress-do-2776ca45a669d481fe14c9f645a94eca.png";